import { render, staticRenderFns } from "./media_carousel_item.vue?vue&type=template&id=476d1ca1&lang=pug"
import script from "./media_carousel_item.vue?vue&type=script&lang=js"
export * from "./media_carousel_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports